module.exports = __webpack_public_path__ + "media/images/lb/297-7fb92e9cb0b6c9bdcaad5221d26a0df4.svg";